"use client";

import Image, { StaticImageData } from "next/image";
import Link from "next/link";

import { Translation } from "@/data/lang";
import { useLang } from "@/hooks/use-lang";
import Comma from "@/public/home/comma.svg";

import { ButtonCarousel } from "ui/widget/button-carousel";

import { getNewsData } from "../data/news";
import LeftArrowBox from "./left-arrow-box";

export const NewsSection = () => {
  const { t } = useLang();
  const newsData = getNewsData(t);

  return (
    <div className="flex min-h-screen-dvh w-full items-center justify-center p-7 md:p-20">
      <div className="w-full max-w-[var(--home-page-width)]">
        <ButtonCarousel
          data={newsData.map((item) => (
            <CarouselItem
              t={t}
              key={item.title}
              title={item.title}
              content={item.content}
              url={item.url}
              logo={item.logo}
              image={item.image}
            />
          ))}
          switchButtonIcon={<LeftArrowBox />}
          switchButtonsClassName="flex"
        />
      </div>
    </div>
  );
};

const CarouselItem = ({
  t,
  title,
  content,
  url,
  logo,
  image,
}: {
  t: Translation;
  title: string;
  content: string;
  url: string;
  logo: StaticImageData;
  image: StaticImageData;
}) => (
  <div className="relative flex flex-col-reverse items-center gap-10 px-1 @[700px]:flex-row @[700px]:gap-16 lg:px-10">
    <Image
      alt="comma"
      src={Comma as StaticImageData}
      className="absolute right-0 top-0 hidden h-[70px] w-[70px] rotate-180 lg:inline-block"
    />
    {/* image */}
    <div className="relative h-full w-full max-w-[500px] @[300px]:py-6 @[300px]:pl-6 @[700px]:max-w-[40%] lg:py-10 lg:pl-10">
      <div
        style={{
          borderImage: "linear-gradient(10deg, #14B3BC, #8EDC99) 90",
          borderStyle: "solid",
        }}
        className="absolute left-0 top-0 z-[-1] box-border hidden h-full w-[70%] border-[10px] after:absolute after:-bottom-4 after:-right-4 after:h-[20%] after:w-[80%] after:bg-white @[300px]:inline-block lg:border-[16px]"
      />
      <Image
        src={image}
        alt="news-image"
        className="h-full w-full object-contain"
      />
    </div>
    {/* contents */}
    <div className="flex w-full flex-col gap-y-4 lg:py-6">
      <Image
        src={logo}
        alt="news-logo"
        className="w-full max-w-[100px] @[700px]:max-w-[180px]"
      />
      <h2 className="text-xl font-bold lg:text-2xl 2xl:text-3xl">{title}</h2>
      <div>
        <p>{content}</p>
        <Link href={url} target="_blank" aria-label="go to news page">
          <p className="text-green-500">{t.home.learnMore}</p>
        </Link>
      </div>
    </div>
  </div>
);
